import { getDatabase, ref } from "firebase/database";

import { initializeApp as firebaseInit } from "firebase/app";

const app = firebaseInit(
    {
        apiKey: "AAAAA7A7itc:APA91bGk0ZafnCxTD40Mp7_hJyHiFp9UY23Ie0Aeb2_bOiviiB85Ong7yqYUu-cn012aM3jWFakPDBgeUItjVVQyGNjL-eJm5liuBrQ2noX3KrgnpaBqmoAbCQmuSgC6cJaHTa64HNEm",
        authDomain: "crmv2-helpdesk-default-rtdb.firebaseio.com",
        databaseURL: "https://capys-cliente.firebaseio.com/",
        storageBucket: "",
    },
    `firebaseClienteInstanceAt${Date.now()}`
);
const db = getDatabase(app);

export function getUsuariosOnlineCRMV2Ref(idOrg: string) {
    return ref(db, `${idOrg}/CRMV2/USUARIOS`);
}

export function getUsuarioConexaoCRMV2Ref(idOrg: string, idUsuario: number) {
    return ref(db, `${idOrg}/CRMV2/USUARIOS/${idUsuario}/CONEXOES/`);
}

export function getNotificacoesAlertaCRMV2Ref(
    idOrg: string,
    idUsuario: number
) {
    return ref(db, `${idOrg}/CRMV2/USUARIOS/${idUsuario}/NOTIALERTAS/`);
}

export function getNotificacoesURACRMV2Ref(idOrg: string, idUsuario: number) {
    return ref(db, `${idOrg}/CRMV2/USUARIOS/${idUsuario}/NOTI_URA`);
}

export function getFirebaseClienteInstanceName() {
    return app.name;
}
